module.exports = __webpack_public_path__ + "static/media/icon_trash-success.6c42ece0.svg";